import React from 'react';
import PatientsAutoComplete from 'components/autocomplete/PatientsAutoComplete';
import { useNewSurgerie } from '../../hooks/useNewSurgerie';
import { PersonSearchOutlined } from '@mui/icons-material';
import { Chip, Typography } from '@mui/material';
import { CardBody, GuidedCard, GuidedHeader, HelperNote, SoftPanel } from '../../components/GuidedSurgerie';

const SurgerieFirstStep: React.FC = () => {
  const { surgerie, handleChange, validation } = useNewSurgerie();
  return (
    <GuidedCard>
      <GuidedHeader
        step={1}
        title="Paciente"
        description="Comece identificando para quem o orçamento será emitido."
        aside={surgerie.patient ? <Chip color="success" size="small" label="Paciente selecionado" /> : undefined}
      />
      <CardBody>
        <SoftPanel>
          <Typography variant="subtitle2" gutterBottom>
            Busque pelo paciente
          </Typography>
          <PatientsAutoComplete
            label="Informe o paciente"
            onSelect={patient => {
              handleChange('patient', patient);
              handleChange('patient_id', patient?.id ?? null);
            }}
            placeholder="Digite o nome do paciente"
            selected={surgerie.patient}
            error={!!validation}
            helperText={validation}
          />
        </SoftPanel>

        {surgerie.patient ? (
          <SoftPanel>
            <Typography variant="body2" fontWeight={700}>
              {surgerie.patient.name}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              CPF: {surgerie.patient.document_number || 'Não informado'} • Telefone:{' '}
              {surgerie.patient.phone || surgerie.patient.fixed_phone || 'Não informado'}
            </Typography>
          </SoftPanel>
        ) : (
          <HelperNote>
            <PersonSearchOutlined fontSize="small" />
            <Typography variant="caption">
              Selecione um paciente já cadastrado para que o orçamento siga com os dados corretos.
            </Typography>
          </HelperNote>
        )}
      </CardBody>
    </GuidedCard>
  );
};

export default SurgerieFirstStep;
